import '../../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@apollo/client';
import { MUTATION } from '../../../gql-operations';
import AuthLayout from '../AuthLayout';

const ResetPasswordPage = (props) => {
    const {t: lnT} = useTranslation();

    // const [password, setPassword] = useState('');
    // const [repeatPassword, setRepeatPassword] = useState('');
    // const [token, setToken] = useState(props.match.params.token);

    // useEffect(() => {
    //     console.log(token);
    // }, [token]);

    const [resetPassword, { data, error }] = useMutation(MUTATION.RESET_PASSWORD_MAIL);

    const renderMessage = () => {
        if (data && data.resetPassword) {
            return (
                <div className="auth-alert auth-alert--success">
                    <span className="auth-alert-icon">✓</span>
                    <span className="auth-alert-body">{lnT('auth:emailSentSuccessfullyPleaseCheckYourInbox')}</span>
                </div>
            );
        } else if (error) {
            return (
                <div className="auth-alert auth-alert--error">
                    <span className="auth-alert-icon">⚠</span>
                    <span className="auth-alert-body">
                        {error.graphQLErrors.length > 0
                            ? error.graphQLErrors.map(x => x.message).join(', ')
                            : lnT('auth:serverErrorWeLlBeBackSoon')}
                    </span>
                </div>
            );
        }
    };

    return (
        <AuthLayout>
            <Formik
                initialValues={{ token: props.match.params.token }}
                onSubmit={async (values, actions) => {
                    await resetPassword({
                        variables: {
                            data: {
                                newPassword: values.password,
                                token: values.token
                            }
                        }
                    });
                    props.history.push('/login');
                    actions.setSubmitting(false);
                }}
                validationSchema={Yup.object().shape({
                    password: Yup.string()
                        .min(6, lnT('auth:minimumPasswordLengthIs6'))
                        .max(50, lnT('auth:maximumPasswordLengthIs50'))
                        .required(lnT('auth:youNeedToHaveAPassword')),
                    repeatPassword: Yup.string()
                        .oneOf([Yup.ref('password'), null], 'Passwords must match')
                        .min(6, lnT('auth:minimumPasswordLengthIs6'))
                        .max(50, lnT('auth:maximumPasswordLengthIs50'))
                        .required(lnT('auth:pleaseRepeatYourPasswordAgain'))
                })}
            >
                {({ values, handleSubmit, handleChange, handleBlur, errors, touched }) => (
                    <>
                        <h1 className="auth-title">{lnT('auth:resetYourPassword')}</h1>
                        <p className="auth-subtitle">{lnT('auth:chooseANewPasswordForYourAccount')}</p>

                        {renderMessage()}

                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="auth-field">
                                <input
                                    type="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    placeholder={lnT('common:password')}
                                    name="password"
                                />
                                {errors.password && (
                                    <div id="password" className="error">
                                        {errors.password}
                                    </div>
                                )}
                            </div>

                            <div className="auth-field">
                                <input
                                    type="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.repeatPassword}
                                    placeholder={lnT('auth:repeatPassword')}
                                    name="repeatPassword"
                                />
                                {errors.repeatPassword && (
                                    <div id="repeatPassword" className="error">
                                        {errors.repeatPassword}
                                    </div>
                                )}
                            </div>

                            <button type="submit" className="auth-submit">{lnT('auth:resetPassword')}</button>
                        </form>
                    </>
                )}
            </Formik>
        </AuthLayout>
    );
}

export default ResetPasswordPage;
